// extracted by mini-css-extract-plugin
module.exports = {"pr15":"styles_pr15__3rKJD","attachItem":"styles_attachItem__3ppW6","deleteBt":"styles_deleteBt__eOH87"};